
import {mapMutations} from 'vuex';
import Gamburger from './Gamburger';
import {catalogMenuSections} from '../utils/catalogMenu';

export default {
    name: 'HeaderMobileMenu',
    components: {Gamburger},
    data() {
        return {
            activeMenuId: null,
            previousBodyOverflow: null,
        };
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('resize', this.handleResize);
        if (this.menuState) this.syncMenuState(true);
        this.handleResize();
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('resize', this.handleResize);
        this.restoreBodyScroll();
    },
    watch: {
        menuState: 'syncMenuState',
        $route() {
            this.close();
        },
    },
    computed: {
        menus() {
            return [
                {id: 'catalog', name: 'Каталог', sections: catalogMenuSections},
                {id: 'about', name: 'О бренде', url: '/about/'},
                {id: 'partnership', name: 'Сотрудничество', url: '/partnership/'},
                {id: 'contacts', name: 'Контакты', url: '/contacts/'},
            ];
        },
        activeMenu() {
            return this.menus.find(menu => menu.id === this.activeMenuId) || null;
        },
        menuState() {
            return this.$store.state.mobileMenu.catalog;
        },
    },
    methods: {
        ...mapMutations({
            toggleMobileMenu: 'toggleMenuCatalog',
            closeMobileMenu: 'closeMenuCatalog',
        }),
        toggle() {
            this.toggleMobileMenu();
        },
        close() {
            this.closeMobileMenu();
        },
        showMenu(id) {
            if (!this.menus.some(menu => menu.id === id && menu.sections)) return;
            this.activeMenuId = id;
            this.focusPanelItem('.header-mobile-menu__link');
        },
        showMainMenu() {
            const previousMenuId = this.activeMenuId;
            this.activeMenuId = null;
            this.focusPanelItem('[data-menu-id="' + previousMenuId + '"]');
        },
        focusPanelItem(selector) {
            this.$nextTick(() => {
                const panel = this.$refs.panel;
                if (!panel) return;
                panel.scrollTop = 0;
                const target = panel.querySelector(selector) || panel;
                target.focus({preventScroll: true});
            });
        },
        syncMenuState(open) {
            this.activeMenuId = null;
            if (open) {
                this.previousBodyOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
                // Do not focus the search input: it would open the mobile keyboard.
                this.focusPanelItem('[data-menu-id="catalog"]');
            } else {
                this.restoreBodyScroll();
                const panel = this.$refs.panel;
                if (panel && panel.contains(document.activeElement)) {
                    this.$nextTick(() => {
                        const trigger = this.$refs.trigger;
                        if (trigger) trigger.$el.focus({preventScroll: true});
                    });
                }
            }
        },
        restoreBodyScroll() {
            if (this.previousBodyOverflow !== null) {
                document.body.style.overflow = this.previousBodyOverflow;
                this.previousBodyOverflow = null;
            }
        },
        handleResize() {
            if (window.innerWidth >= 1024 && this.menuState) this.close();
        },
        handleKeydown(event) {
            if (!this.menuState) return;

            if (event.key === 'Escape') {
                event.preventDefault();
                if (this.activeMenu) this.showMainMenu();
                else this.close();
            }

            if (event.key === 'Tab' && this.$refs.panel) {
                const panel = this.$refs.panel;
                const items = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
                const first = items[0];
                const last = items[items.length - 1];
                if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel)) {
                    event.preventDefault();
                    first.focus();
                }
            }
        },
    },
};
